import angular from 'angular'



let inject = [
    '$scope',
    'ShoppingExperienceService',
    '$state',
    '$rootScope',
    '$uibModal',
    '$timeout',
    '$stateParams',
    '$window'
];

class ShoppingExperienceController {
    constructor($scope, ShoppingExperienceService, $state, $rootScope, $uibModal, $timeout, $stateParams, $window) {
        this.$state = $state;
        this.ShoppingExperienceService = ShoppingExperienceService;
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;


        this.alreadySend = false;
        this.dataForm = {};
        this.alreadySend = false;


    }

    $onInit() {
        this.cargarData()
    }

    cargarData(){

        if(this.shCtrl.experience_comment){
            this.alreadySend = true;
            this.dataForm.rating = this.shCtrl.experience_rating;
            this.dataForm.comment = this.shCtrl.experience_comment;
        }

    }

    submit(submitForm) {
        if (submitForm.$valid && this.dataForm.rating > 0) {

            let params = {
                orderId: this.shCtrl.id,
                qualification: this.dataForm.rating,
                commentary: this.dataForm.comment
            };

            this.ShoppingExperienceService.sendExperienceComment(params).then(value => {

                if (!value.error) {
                    this.alreadySend = true;
                    // this.dataForm.comment = '';
                    // submitForm.comment.$pristine = true;
                    
                }


            }).catch(err => {
                console.log(err);
            });

        } else {
            angular.forEach(submitForm.$error.required, function (field) {
                field.$setDirty();
            });

            if (this.dataForm.rating === 0 || !this.ratingSelected) {
                this.ratingSelected = true;
            }
        }
    }

    onItemRating(rating) {
        this.dataForm["rating"] = rating;
        this.ratingSelected = rating === 0;
    }

 
   
}

ShoppingExperienceController.$inject = inject;

export default ShoppingExperienceController;




/** WEBPACK FOOTER **
 ** ./www/components/shopping-experience/shopping-experience.controller.js
 **/